module.exports = __webpack_public_path__ + "static/media/battles-info-screen-2.7115ae47.png";